export function scrollToTop(condition) {
    if (condition) {
        return (dispatch) => {
            dispatch({
                type: 'SCROLL_TO_TOP_ENABLE'
            });

            return Promise.resolve(true);
        }
    } else {
        return (dispatch) => {
            dispatch({
                type: 'SCROLL_TO_TOP_DISABLE'
            });

            return Promise.resolve(true);
        }
    }
}

export function showTopBar() {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_TOP_BAR'
        });

        return Promise.resolve(true);
    }
}

export function hideTopBar() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_TOP_BAR'
        });

        return Promise.resolve(true);
    }
}

export function showNavBar() {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_NAV_BAR'
        });

        return Promise.resolve(true);
    }
}

export function hideNavBar() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_NAV_BAR'
        });

        return Promise.resolve(true);
    }
}

export function showSubBar() {
    return (dispatch) => {
        dispatch({
            type: 'SHOW_SUB_BAR'
        });

        return Promise.resolve(true);
    }
}

export function hideSubBar() {
    return (dispatch) => {
        dispatch({
            type: 'HIDE_SUB_BAR'
        });

        return Promise.resolve(true);
    }
}


// WEBPACK FOOTER //
// ./src/core/store/actions/layout.js